import {Button, Popover, Space} from "antd";
import Avatar from "antd/es/avatar/avatar";
import React, {useContext, useEffect, useState} from "react";
import {Header} from "antd/es/layout/layout";
import {ExportOutlined, SettingOutlined} from "@ant-design/icons";
import {postAuthLogout} from "../../database/auth/auth";
import {Context} from "../../App";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import DB_User from "../../database/admin/user";
import ModalWindow from "../modal";


const HeaderMenu = () => {
    const {token, user, setToken} = useContext(Context);
    // const {removeToken} = useToken();
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const {changeLang} = DB_User(token);
    const [userInitials, setUserInitials] = useState()
    const [userAvatar, setUserAvatar] = useState()
    const {errorConnect} = ModalWindow();


    useEffect(() => {
        if (user.id != null) {
            setUserInitials(user.name.split(" ")
                .map((l, i) => {
                    if (i < 3) {
                        return l[0]
                    }
                }))
        }
        if (user.avatar != null) {
            setUserAvatar(user.avatar)
        }
    }, [user])

    const Logout = () => {
        const formData = new FormData();
        formData.append('token', token)


        postAuthLogout(formData)
            .then(res => {
                if (res.status === 200) {
                    setToken(null)
                    // removeToken(token);
                    // window.location.reload();
                }
            })
            .catch(e => {
                if (e.request.status === 401) {
                    setToken(null)
                } else {
                    errorConnect()
                }
            })

    }

    const settings = () => {
        navigate("site/user/settings")
        setVisible(false)
    }

    const changeLan = (lang) => {
        // i18n.changeLanguage(lang)

        changeLang(user.id, lang)
            .then(res => {
                window.location.reload()
            })

    }

    const content = (
        <div>
            <div style={{display: 'flex'}}>
                <Avatar  size={40} style={{
                    marginRight: '16px',
                    // borderRadius: '5pt',
                    color: '#3c7586',
                    backgroundColor: '#cee8e9',
                    // border: '1px solid #ffbb96'
                }} src={user.avatar}>{userInitials}</Avatar>
                <div>
                    <p style={{fontFamily: 'Montserrat-Medium, serif'}}>{user.name}</p>
                    <p style={{fontSize: '8pt', color: '#1d57c4'}}>{t(user.role)}</p>
                </div>
            </div>
            <div style={{margin: '10pt 0 10pt 0', display: 'table-caption'}}>

                <Button onClick={settings} type={'link'} size={'middle'} icon={<SettingOutlined/>}
                        style={{padding: '0'}}>{t('settings')}</Button>
                <Button onClick={Logout} type={'link'} size={'middle'} icon={<ExportOutlined/>}
                        style={{padding: '0'}}>{t('exit')}</Button>
            </div>
            {/*<Segmented*/}
            {/*    size="small"*/}
            {/*    onChange={changeLan}*/}
            {/*    value={user.lang}*/}
            {/*    options={[*/}
            {/*        {*/}
            {/*            label: '🇺🇸',*/}
            {/*            value: 'en_US',*/}
            {/*        },*/}
            {/*        {*/}
            {/*            label: '🇺🇦',*/}
            {/*            value: 'uk_UA',*/}

            {/*        },*/}
            {/*        {*/}
            {/*            label: '🇷🇺',*/}
            {/*            value: 'ru_RU',*/}

            {/*        },*/}
            {/*    ]}/>*/}

        </div>
    );

    const handleVisibleChange = (newVisible) => {
        setVisible(newVisible);
    };


    return (
        <Header style={{
            background: '#f0f2f5',
            height: 'auto',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
        }}>
            <Space style={{display: 'contents'}}>
                <Popover
                    placement="bottomRight"
                    content={content}
                    trigger="click"
                    onVisibleChange={handleVisibleChange}
                    visible={visible}
                >
                    <Avatar src={userAvatar} style={{
                        marginTop: '10pt',
                        cursor: 'pointer',
                        color: '#3c7586',
                        backgroundColor: '#cee8e9',
                    }}>{userInitials}</Avatar>
                </Popover>
            </Space>
        </Header>
    )
}

export default HeaderMenu